function attachBuyOptionEvents() {
  // Product selector
  const elements = document.querySelectorAll('[buy-option]');
  elements.forEach(el => {
    el.addEventListener('click', () => {
      const optionValue = el.getAttribute('buy-option');
      const buyOptionSelected = document.querySelector(`[product-related="${optionValue}"] .plan-information .input-wrapper input:checked`);
      const price = buyOptionSelected.closest('.plan-information').querySelector('.final-price').textContent;
      const comparePrice = buyOptionSelected.closest('.plan-information').querySelector('.compare-price').textContent;
      const selectedVariant = document.querySelector(`[product-related="${optionValue}"] input.variant-option-input:checked`).value;
      
      const selling_plan_elem = document.querySelector(`[product-related="${optionValue}"] [variant-related="option-${selectedVariant}"] [selling-plan-selector]`);
      let selling_plan = '';
      if (selling_plan_elem) {
        selling_plan = selling_plan_elem.value;
        document.querySelector(`[product-related="${optionValue}"] [subscription].plan-information`).classList.remove('display-none');
        document.querySelector(`[product-related="${optionValue}"] divider`).classList.remove('display-none');
      } else {
        const subscriptionPlan = document.querySelector(`[product-related="${optionValue}"] [subscription].plan-information`);
        if (subscriptionPlan) {
          subscriptionPlan.classList.add('display-none');
        }
        document.querySelector(`[product-related="${optionValue}"] divider`)?.classList.add('display-none');
        document.querySelector(`[product-related="${optionValue}"] [one-time].plan-information label`).click();
      }
      
      document.body.setAttribute('selected-product', optionValue);
      document.querySelector('#button-price').textContent = price;
      document.querySelector('#button-compare-price').textContent = comparePrice;
      const fixedPriceElem = document.querySelector('.fixed-atc-content-price');
      if (fixedPriceElem) {
        fixedPriceElem.textContent = price;
      }
      const fixedComparePriceElem = document.querySelector('.fixed-compare-content-price');
      if (fixedComparePriceElem) {
        fixedComparePriceElem.textContent = comparePrice;
      }
      document.querySelector('[is="product-form"] input[name="id"]').value = selectedVariant;
      
      const allPoints = document.querySelectorAll('.points-to-update');
      hideElems(allPoints);
      const pointsToShow = document.querySelectorAll(`.points-to-update[related-variant="id-${ selectedVariant }"]`);
      pointsToShow.forEach(el => {
        el.classList.remove('display-none');
      });

      if (buyOptionSelected.classList.contains('one-time-plan') || (selling_plan == '')) {
        document.querySelector('[is="product-form"] input[name="selling_plan"]').value = '';
        buyOptionSelected.setAttribute('seling-plan-id', '');
        const allRewards =  document.querySelectorAll('[reward]');
        allRewards.forEach(el => {
          el.classList.add('locked');
        });
        updateProductUrl(optionValue, selectedVariant,'');
      } else {
        document.querySelector('[is="product-form"] input[name="selling_plan"]').value = selling_plan;
        buyOptionSelected.setAttribute('seling-plan-id', selling_plan);
        const labelData = document.querySelector(`[variant-selector][related-variant="option-${selectedVariant}"`);
        const rewardUnlock = labelData.getAttribute('unlock-level');
        const allRewards =  document.querySelectorAll('[reward]');
        const allRewardsToUnlock =  document.querySelectorAll(`[reward].${rewardUnlock}`);
        allRewards.forEach(el => {
          el.classList.add('locked');
        });
        allRewardsToUnlock.forEach((el,index) => {
          el.classList.remove('locked');
        });
        updateProductUrl(optionValue, selectedVariant,selling_plan);
      }
    });
  });
  // Variant selector
  const variantSelectors = document.querySelectorAll('[variant-selector]');
  variantSelectors.forEach(el => {
    el.addEventListener('click', (event) => {
      const optionValue = el.getAttribute('related-variant');
      const variantId = optionValue.replace('option-', '');
      const oneTimePrice = el.getAttribute('data-price');
      const oneTimeComparePrice = el.getAttribute('data-compare-price');
      const parentProduct = el.closest("[product-related]").getAttribute('product-related');
      const relatedPlan = document.querySelector(`[variant-related="${optionValue}"]`);
      const allPlans = document.querySelectorAll(`[plans][product-related="${parentProduct}"] [variant-dependency]`);
      const rewardUnlock = el.getAttribute('unlock-level');
      const buyOptionSelected = document.querySelector(`[product-related="${parentProduct}"] .plan-information .input-wrapper input:checked`);
      
      const selling_plan_elem = document.querySelector(`[product-related="${parentProduct}"] [variant-related="${optionValue}"] [selling-plan-selector]`);
      let selling_plan = '';
      if (selling_plan_elem) {
        selling_plan = selling_plan_elem.value;
        document.querySelector(`[product-related="${parentProduct}"] [subscription].plan-information`).classList.remove('display-none');
        document.querySelector(`[product-related="${parentProduct}"] divider`).classList.remove('display-none');
      } else {
        document.querySelector(`[product-related="${parentProduct}"] [subscription].plan-information`)?.classList.add('display-none');
        document.querySelector(`[product-related="${parentProduct}"] divider`)?.classList.add('display-none');
        document.querySelector(`[product-related="${parentProduct}"] [one-time].plan-information label`).click();
   
      }

      document.querySelector('[is="product-form"] input[name="id"]').value = variantId;
      hideElems(allPlans);
      if(relatedPlan) {
        relatedPlan.classList.remove('display-none');
      }
      variantUpdate(parentProduct,relatedPlan, oneTimePrice, oneTimeComparePrice);
      const allPoints = document.querySelectorAll('.points-to-update');
      hideElems(allPoints);
      const pointsToShow = document.querySelectorAll(`.points-to-update[related-variant="id-${ variantId }"]`);
      pointsToShow.forEach(el => {
        el.classList.remove('display-none');
      });

      if (buyOptionSelected.classList.contains('one-time-plan') || (selling_plan == '')) {
        document.querySelector('[is="product-form"] input[name="selling_plan"]').value = '';
        buyOptionSelected.setAttribute('seling-plan-id', '');
        updateProductUrl(parentProduct, variantId,'');
      } else {
        document.querySelector('[is="product-form"] input[name="selling_plan"]').value = selling_plan;
        buyOptionSelected.setAttribute('seling-plan-id', selling_plan);
        if (rewardUnlock) {
          const allRewards =  document.querySelectorAll('[reward]');
          const allRewardsToUnlock =  document.querySelectorAll(`[reward].${rewardUnlock}`);
          allRewards.forEach(el => {
            el.classList.add('locked');
          });
          allRewardsToUnlock.forEach((el,index) => {
            el.classList.remove('locked');
          });
        }
        updateProductUrl(parentProduct, variantId, selling_plan);
      }
    });
  });
} 
// Buy option selector
const planInputs = document.querySelectorAll('.selling-plan-option-input');
planInputs.forEach(planInput => {
  planInput.addEventListener('change', (event) => {
    const selectedProduct = document.body.getAttribute('selected-product');
    const wrapper = planInput.closest('.plan-information');
    const price = wrapper.querySelector('.final-price').textContent;
    const comparePrice = wrapper.querySelector('.compare-price').textContent;
    const planTimePrices = document.querySelectorAll('.plan-option-price-item');
    const allOneTimePrices = document.querySelectorAll('.option-price-item');
    const planTimeDiscount = document.querySelectorAll('.plan-discount-per-unit');
    const allSubscriptionsBlock = document.querySelectorAll(`[plans][product-related="${selectedProduct}"] .subscription-hidden`);
    const allOneTimeDiscount = document.querySelectorAll('.discount-per-unit');
    document.querySelector('#button-price').textContent = price;
    document.querySelector('#button-compare-price').textContent = comparePrice;
    const fixedPriceElem = document.querySelector('.fixed-atc-content-price');
    if (fixedPriceElem) {
      fixedPriceElem.textContent = price;
    }
    const fixedComparePriceElem = document.querySelector('.fixed-compare-content-price');
    if (fixedComparePriceElem) {
      fixedComparePriceElem.textContent = comparePrice;
    }
    if (event.target.classList.contains('subscription-plan')) {
      hideElems(allOneTimePrices);
      showElemsAsBlock(planTimePrices);
      hideElems(allOneTimeDiscount);
      showElemsAsBlock(planTimeDiscount);
      const selectedVariant = document.querySelector('[is="product-form"] input[name="id"]').value;
      const selling_plan = document.querySelector(`[variant-related="option-${selectedVariant}"] [selling-plan-selector]`).value;
      document.querySelector('[is="product-form"] input[name="selling_plan"]').value = selling_plan;
      const labelData = document.querySelector(`[variant-selector][related-variant="option-${selectedVariant}"`);
      const rewardUnlock = labelData.getAttribute('unlock-level');
      const allRewards =  document.querySelectorAll('[reward]');
      const allRewardsToUnlock =  document.querySelectorAll(`[reward].${rewardUnlock}`);
      showElemsAsBlock(allSubscriptionsBlock);
      updateProductUrl(selectedProduct, selectedVariant, selling_plan);
      allRewards.forEach(el => {
        el.classList.add('locked');
      });
      allRewardsToUnlock.forEach((el,index) => {
        el.classList.remove('locked');
      });
    } else {
      hideElems(planTimePrices);
      showElemsAsBlock(allOneTimePrices);
      hideElems(planTimeDiscount);
      showElemsAsBlock(allOneTimeDiscount);
      const allRewards =  document.querySelectorAll('[reward]');
      allRewards.forEach(el => {
        el.classList.add('locked');
      });
      document.querySelector('[is="product-form"] input[name="selling_plan"]').value = '';
      const selectedVariant = document.querySelector('[is="product-form"] input[name="id"]').value;
      updateProductUrl(selectedProduct, selectedVariant, '');
      hideElems(allSubscriptionsBlock);
    }
  });
});
// Plan selector 
// Custom Selector 
const selectors = document.querySelectorAll('.custom-select-selected');
selectors.forEach(selector => {
  selector.addEventListener('click', (event) => {
    if (selector.classList.contains('open')) {
      selector.classList.remove('open');
    } else {
      selector.classList.add('open');
    }
  });
});
const options = document.querySelectorAll('.custom-option');
options.forEach(option => {
  option.addEventListener('click', (event) => {
    const selectorWrapper = option.closest('.custom-select-wrapper');
    const selector = selectorWrapper.querySelector('.custom-select-selected ');
    const selectedText = option.textContent;
    const selectedId = option.getAttribute('value');
    const input = selectorWrapper.querySelector('.input-selector');
    if (input.classList.contains('selling-plan-input-select')){
          document.querySelector('[is="product-form"] input[name="selling_plan"]').value = selectedId;
          const selectedProduct = document.body.getAttribute('selected-product');
          const selectedVariant = document.querySelector('[is="product-form"] input[name="id"]').value;
          updateProductUrl(selectedProduct, selectedVariant, selectedId);
    }
    if (selector) {
      selector.querySelector('.text-content').textContent = selectedText;
      input.value = selectedId;
      selector.classList.remove('open');
    };
  });
});

// Close custom select when clicking outside
document.addEventListener('click', (event) => {
  const insideWrapper = event.target.closest && event.target.closest('.custom-select-wrapper');
  if (insideWrapper) return;
  document.querySelectorAll('.custom-select-selected.open').forEach((el) => { 
    el.classList.remove('open');
  });
});
// Tabs
let savedSelectedFlavor; 
let flavorPreSelected;
let savedSelectedBundle; 
let bundlePreSelected;

const singleProductTab = document.querySelector('[single-product]');
singleProductTab.addEventListener('click', (event) => {
  const elemsToHide = document.querySelectorAll('.single-product[bundle-product]');
  const elemsToShow = document.querySelectorAll('.single-product[single-product]');
  const selectedTab = document.querySelector('[bundle-product].buy-option-selected');
  if (selectedTab) {
    selectedTab.classList.remove('buy-option-selected');
    singleProductTab.classList.add('buy-option-selected');
    savedSelectedBundle = document.body.getAttribute('selected-product'); 
    bundlePreSelected = document.querySelector(`[bundle-product][buy-option="${savedSelectedBundle}"]`);
    if (flavorPreSelected == undefined) {
      document.querySelector('[buy-option][single-product]').click();
    } else {
      flavorPreSelected.click();
    }
  }
  hideElems(elemsToHide);
  showElemsAsBlock(elemsToShow);
});

const bundleProductTab = document.querySelector('[bundle-product]');
bundleProductTab.addEventListener('click', (event) => {
  const elemsToHide = document.querySelectorAll('.single-product[single-product]');
  const elemsToShow = document.querySelectorAll('.single-product[bundle-product]');
  const selectedTab = document.querySelector('[single-product].buy-option-selected');
  if (selectedTab) { 
    selectedTab.classList.remove('buy-option-selected');
    bundleProductTab.classList.add('buy-option-selected');
    savedSelectedFlavor = document.body.getAttribute('selected-product'); 
    flavorPreSelected = document.querySelector(`[single-product][buy-option="${savedSelectedFlavor}"]`);
    if (bundlePreSelected == undefined) {
      document.querySelector('[buy-option][bundle-product]').click();
    } else {
      bundlePreSelected.click();
    }
  }
  hideElems(elemsToHide);
  showElemsAsBlock(elemsToShow);
});
// Functions
function hideElems (element) {
  element.forEach(el => {
    el.classList.remove('display-flex');
    el.classList.remove('display-block');
    el.classList.add('display-none');
  });
}

function showElemsAsBlock (element) {
  element.forEach(el => {
    el.classList.add('display-block');
    el.classList.remove('display-none');
  });
}

function variantUpdate(parentProduct,relatedPlan, oneTimePrice, oneTimeComparePrice) {
  let selling_plan_id = '';
  let price = '';
  let priceFormat = '';
  let comparePrice = '';
  let comparePriceFormat = '';
  const planTypeSelected = document.querySelector(`[product-related="${parentProduct}"] .selling-plan-option-input:checked`);
  const planTimePrices = document.querySelectorAll('.plan-option-price-item');
  const allOneTimePrices = document.querySelectorAll('.option-price-item');
  const planTimeDiscount = document.querySelectorAll('.plan-discount-per-unit');
  const allOneTimeDiscount = document.querySelectorAll('.discount-per-unit');
  if (relatedPlan){
    selling_plan_id = relatedPlan.querySelector('[selling-plan-selector]').value;
    price = relatedPlan.querySelector(`.custom-option[value="${selling_plan_id}"]`).getAttribute('plan-price');
    priceFormat = relatedPlan.querySelector(`.custom-option[value="${selling_plan_id}"]`).getAttribute('plan-price-format');
    comparePrice = relatedPlan.querySelector(`.custom-option[value="${selling_plan_id}"]`).getAttribute('plan-compare-price');
    comparePriceFormat = relatedPlan.querySelector(`.custom-option[value="${selling_plan_id}"]`).getAttribute('plan-compare-price-format');
    document.querySelector(`[product-related="${parentProduct}"] .plan-information[subscription] .final-price`).textContent = priceFormat;
    document.querySelector(`[product-related="${parentProduct}"] .plan-information[subscription] .compare-price`).textContent = comparePriceFormat;
  }
  document.querySelector(`[product-related="${parentProduct}"] .plan-information[one-time] .final-price`).textContent = oneTimePrice;
  document.querySelector(`[product-related="${parentProduct}"] .plan-information[one-time] .compare-price`).textContent = oneTimeComparePrice;
  updateDiscountLabel(price,comparePrice);
  if (planTypeSelected.classList.contains('subscription-plan')) {
    hideElems(allOneTimePrices);
    showElemsAsBlock(planTimePrices);
    hideElems(allOneTimeDiscount);
    showElemsAsBlock(planTimeDiscount);
    document.querySelector('#button-price').textContent = priceFormat;
    document.querySelector('#button-compare-price').textContent = comparePriceFormat;
    const fixedPriceElem = document.querySelector('.fixed-atc-content-price');
    if (fixedPriceElem) {
      fixedPriceElem.textContent = priceFormat;
    }
    const fixedComparePriceElem = document.querySelector('.fixed-compare-content-price');
    if (fixedComparePriceElem) {
      fixedComparePriceElem.textContent = comparePriceFormat;
    }
  } else {
    hideElems(planTimePrices);
    showElemsAsBlock(allOneTimePrices);
    hideElems(planTimeDiscount);
    showElemsAsBlock(allOneTimeDiscount);
    document.querySelector('#button-price').textContent = oneTimePrice;
    document.querySelector('#button-compare-price').textContent = oneTimeComparePrice;
    const fixedPriceElem = document.querySelector('.fixed-atc-content-price');
    if (fixedPriceElem) {
      fixedPriceElem.textContent = oneTimePrice;
    }
    const fixedComparePriceElem = document.querySelector('.fixed-compare-content-price');
    if (fixedComparePriceElem) {
      fixedComparePriceElem.textContent = oneTimeComparePrice;
    }
  }
}
document.addEventListener('DOMContentLoaded', attachBuyOptionEvents());

function updateProductUrl(productHandle, variantId, sellingPlan) {
  let sellingPlanUrl = ''
  if (sellingPlan != '') {
    sellingPlanUrl = `&selling_plan=${sellingPlan}`;
  }
  const newUrl = `/products/${productHandle}?variant=${variantId}${sellingPlanUrl}&view=product-v2`;
  window.history.replaceState({}, '', newUrl);
}

function updateDiscountLabel(price, comparePrice) {
  let discount = ((comparePrice - price) / comparePrice) * 100;
  
  discount = Math.round(discount);
  
  const discountLabels = document.querySelectorAll('.plan-name .discount-label');
  discountLabels.forEach(label => {
    if (discount > 0) {
      label.textContent = `SAVE ${discount}%`;
      label.style.display = 'inline-flex';
    } else {
      label.style.display = 'none';
    }
  });
  
  return discount;
}
// Example usage when a new product is selected:

(function attachCustomRadioDelegation() {
  document.addEventListener('click', function(e) {
    var custom = e.target.closest && e.target.closest('.custom-radio');
    if (!custom) return;

    var container = custom.parentElement;
    var input = null;
    if (container) {
      if (container.previousElementSibling && container.previousElementSibling.matches && container.previousElementSibling.matches('input[type="radio"]')) {
        input = container.previousElementSibling;
      }
      if (!input) {
        input = container.querySelector && container.querySelector('input[type="radio"]');
      }
    }
    if (!input && custom.previousElementSibling && custom.previousElementSibling.matches && custom.previousElementSibling.matches('input[type="radio"]')) {
      input = custom.previousElementSibling;
    }

    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var nextLabel = custom.nextElementSibling;
    if (nextLabel && nextLabel.tagName === 'LABEL') {
      nextLabel.click();
    }
  });
})();